import { useMemo } from "react";
import { constructLoggedInUserIdHash } from "../../utils/user-utils";

export function useIdHash(id: string) {
    const loggedInUserIdHash = useMemo(() => constructLoggedInUserIdHash(id), [id]);
    return loggedInUserIdHash;
}
